import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useLang } from '@/context/LanguageContext';
import { Navbar } from '@/components/Navbar';
import { Agenda } from '@/components/Agenda';
import { Footer } from '@/components/Footer';
import { ShowModal } from '@/components/ShowModal';
import { Stars } from '@/components/Stars';
import { VideoEdicio } from '@/components/VideoEdicio';
import { ALL_ITEMS, edicioPerRuta } from '@/data/catalog';
import { MapPin } from 'lucide-react';

const RUTA = '/edicio-2026';

// El programa de la edición 2026, guardado.
//
// La portada dejó de anunciar el festival al acabar la edición, pero el
// programa no se ha borrado: vive aquí, con el mismo buscador y las mismas
// fichas que tenía en la portada. Se entra desde el cuadro de 2026 de la
// rejilla de edicions anteriors.
//
// Arriba va el vídeo de la edición, cuando lo hay: sale del bloque "video" de
// esta edición en festivalData.json, y con "actiu": false no se pinta nada.
export default function Edicio2026Page() {
  const { t } = useLang();
  const [activeShow, setActiveShow] = useState(null);
  const edicio = edicioPerRuta(RUTA);

  return (
    <div className="relative min-h-screen bg-[#040f0c] text-white">
      <Navbar variant="pagina" />

      <main>
        <section
          data-testid="edicio-header"
          className="relative overflow-hidden bg-[#040f0c] pt-36 pb-12 sm:pt-40 sm:pb-16"
        >
          <Stars count={30} seed={13} />
          <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6">
            <motion.div
              initial={{ opacity: 0, y: 18 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            >
              <h1 className="font-display font-normal uppercase leading-[0.86] tracking-wide text-5xl sm:text-6xl lg:text-7xl">
                {t.edicio.title}
              </h1>
              <p className="mt-5 max-w-2xl text-white/70">{t.edicio.subtitle}</p>

              <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-3 text-sm font-semibold text-white/75">
                <span className="inline-flex items-center gap-2">
                  <MapPin size={16} className="text-[var(--cea-accent)]" />
                  {t.hero.place}
                </span>
                <span className="text-[var(--cea-accent)]">
                  {ALL_ITEMS.length} {t.edicio.count}
                </span>
              </div>
            </motion.div>

            {/* Vídeo de la edición. No pinta nada si no hay ninguno activo. */}
            <VideoEdicio video={edicio && edicio.video} titol={t.edicio.title} />
          </div>
        </section>

        {/* El mismo buscador y las mismas fichas que tenía la portada. */}
        <Agenda onOpenShow={setActiveShow} showHeader={false} showDates={false} />
      </main>

      <Footer />
      {activeShow && <ShowModal show={activeShow} onClose={() => setActiveShow(null)} showDates={false} />}
    </div>
  );
}
